import React, { useEffect } from "react";
import { Popover, Paper, Stack, Avatar, Typography, Box } from "@mui/material";
import { s3baseUrl } from "src/config";
import LabelRole from "../../LabelRole";
import { capitalCase } from "change-case";
import Iconify from "../../Iconify";

const MentionDetailPopover = ({
  anchorEl,
  user,
  onClose,
  showDetail = false,
  taskCreatorId,
}) => {
  if (!user || !showDetail) return null;

  useEffect(() => {
    if (!anchorEl) return;
    const handleScroll = () => {
      onClose?.();
    };
    window.addEventListener("scroll", handleScroll, true);
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [anchorEl, onClose]);

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      slotProps={{
        paper: {
          onMouseLeave: onClose,
          sx: {
            pointerEvents: "none",
            mt: 1,
            borderRadius: "15px",
            background: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.3)",
            boxShadow: (theme) => theme.customShadows?.z24 || 24,
          },
        },
      }}
      disableRestoreFocus
      sx={{
        pointerEvents: "none",
      }}
    >
      <Paper
        elevation={0}
        sx={{ p: 1.5, width: "auto", bgcolor: "transparent" }}
      >
        <Stack direction="row" spacing={2} alignItems="flex-start">
          <Avatar
            src={s3baseUrl + user.image}
            alt={user.first_name}
            sx={{ width: 45, height: 45, border: "1px solid #00000031" }}
          />
          <Stack spacing={0.5}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Iconify
                icon="solar:user-bold"
                sx={{ width: 15, height: 15, color: "text.secondary" }}
              />
              <Typography
                sx={{ fontWeight: 600, lineHeight: 1.2, fontSize: "0.85rem" }}
              >
                {user.first_name} {user.last_name}
              </Typography>
            </Stack>

            {/* <Stack direction="row" spacing={1} alignItems="center">
              <Iconify
                icon="solar:letter-bold"
                sx={{ width: 15, height: 15, color: "text.secondary" }}
              />
              <Typography
                sx={{
                  fontSize: "11px",
                }}
              >
                {user.email}
              </Typography>
            </Stack> */}

            <Box sx={{ mt: 0.5 }}>
              <LabelRole role={user.role} sx={{ width: "100%" }}>
                {!user.role && user.user_id === taskCreatorId
                  ? "Task Creator"
                  : capitalCase(user.role ?? "No Role")}
              </LabelRole>
            </Box>
          </Stack>
        </Stack>
      </Paper>
    </Popover>
  );
};

export default MentionDetailPopover;
